var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalMicrophoneSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 26,
    viewBox: "0 0 15 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5001 18.6585C10.0363 18.6585 12.0849 16.4821 12.0849 13.8125V4.84598C12.0849 2.17634 10.0363 0 7.5001 0C4.96394 0 2.91528 2.17634 2.91528 4.84598V13.8125C2.91528 16.4821 4.96394 18.6585 7.5001 18.6585Z",
    fill: "#D7EED5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9421 9.28564V13.9111C13.9421 17.4048 11.0519 20.2486 7.55814 20.2486C4.06439 20.2486 1.17421 17.4048 1.17421 13.9111V9.28564H0.0715332V13.9111C0.0715332 17.8111 3.14743 21.0263 7.03582 21.3106V24.9553H2.79921V25.9999H12.143V24.9553H8.1385V21.3106C11.9689 21.0263 14.9287 17.8111 14.9287 13.9111V9.28564H13.9421Z",
    fill: "#D7EED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalMicrophoneSecondary);
export default __webpack_public_path__ + "static/media/modal-microphone-secondary.e858c33d1b7f1907f13ad4cf9507f3bc.svg";
export { ForwardRef as ReactComponent };